import { render, staticRenderFns } from "./SistemasIntegrados.vue?vue&type=template&id=2e633ce8&scoped=true&"
import script from "./SistemasIntegrados.vue?vue&type=script&lang=js&"
export * from "./SistemasIntegrados.vue?vue&type=script&lang=js&"
import style0 from "./SistemasIntegrados.vue?vue&type=style&index=0&id=2e633ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e633ce8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VChip,VCol,VContainer,VIcon,VImg,VRow})
